import KycFormSuccess from "../components/KycFormSuccess";

const KycVerificationSuccess = () => (
  <div className="relative z-10 w-full max-w-md px-6 py-8">
    <div className="mb-8 flex justify-center">
      <img
        src="/logo_kyc_success.png"
        alt="kyc"
        className="h-[129px] w-[121px]"
      />
    </div>
    <KycFormSuccess />
  </div>
);

export default KycVerificationSuccess;
